import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChatFormComponent } from './chat-form/chat-form.component';
import { ChatHeaderComponent } from './chat-header/chat-header.component';
import { ChatListEmptyResultComponent } from './chat-list-empty-result/chat-list-empty-result.component';
import { ChatListSearchComponent } from './chat-list-search/chat-list-search.component';
import { ChatListComponent } from './chat-list/chat-list.component';
import { ChatMarkAllComponent } from './chat-mark-all/chat-mark-all.component';
import { ChatMessageListComponent } from './chat-message-list/chat-message-list.component';
import { ChatNoMessagesComponent } from './chat-no-messages/chat-no-messages.component';
import { NoChatSelectedComponent } from './no-chat-selected/no-chat-selected.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
  ],
  declarations: [
    ChatFormComponent,
    ChatHeaderComponent,
    ChatListEmptyResultComponent,
    ChatListSearchComponent,
    ChatListComponent,
    ChatMarkAllComponent,
    ChatMessageListComponent,
    ChatNoMessagesComponent,
    NoChatSelectedComponent,
  ],
  exports: [
    ChatFormComponent,
    ChatHeaderComponent,
    ChatListEmptyResultComponent,
    ChatListSearchComponent,
    ChatListComponent,
    ChatMarkAllComponent,
    ChatMessageListComponent,
    ChatNoMessagesComponent,
    NoChatSelectedComponent,
  ],
})
export class SharedUiChatModule {}
